import React from 'react'
import { useFetchContext } from '../../../common/FetchContext';
import { urls } from '../../../common/urls';
import moment from 'moment';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
import { generalFilter } from '../../../../util/filter';
import { TravelerModal } from '../../../common/travelerModal';
import { Button, Grid, LinearProgress, TextField, Typography } from '@material-ui/core';
import { ErrorMessage } from "../../../common/ErrorMessage";
import { useRetestRequiredReports } from '../../projectManagementQueries';
import { LSDBCoreTable } from '../../../common/LSDBCoreTable';


const dateFormatter = (dateToFormat: Date) => {
    return `${dateToFormat.toDateString()} ${dateToFormat
        .getUTCHours()
        .toString()
        .padStart(2, "0")}:${dateToFormat
            .getUTCMinutes()
            .toString()
            .padStart(2, "0")}:${dateToFormat
                .getUTCSeconds()
                .toString()
                .padStart(2, "0")}`;
};

export const RetestRequiredReport = () => {
    const [startDate, setStartDate] = React.useState('');
    const [endDate, setEndDate] = React.useState('');
    const [selectedRows, setSelectedRows] = React.useState('');

    const {
        mutateAsync: mutateGetRetestReports,
        data: retestreports,
        error: reportsError,
        isLoading: isLoadingReports,
        isError: isErrorReports,
    } = useRetestRequiredReports();

    const { authAxios } = useFetchContext();

    const handleStartDateChange = (e: { target: { value: React.SetStateAction<string>; }; }) => {

        console.log(e)
        setStartDate(e.target.value);
    };


    const handleSelectedRowsChange = (selectedData: any[]) => {

        const procedure_id = selectedData
            .map((row: any) => row.id);

        if (procedure_id.length === 1) {
            setSelectedRows(procedure_id[0]);
        } else if (procedure_id.length > 1) {
            setSelectedRows(procedure_id.join(","));
        }
        // console.log("Selected Rows:", selectedData);

        // setSelectedRows(selectedData);
    };

    const handleEndDateChange = (e: { target: { value: React.SetStateAction<string>; }; }) => {
        setEndDate(e.target.value);
    };
    const searchData = async () => {


        if (startDate != '' && endDate != '') {
            var data = await mutateGetRetestReports({
                authAxios,
                startDate,
                endDate,
            });

            // setFlashReports(data)

        } else {
            toast.warning('Please select start and end date')

        }


    };

    const [noteID, setNoteID] = React.useState(
        Number((useParams() as { note_id: string }).note_id)
    );
    const [open, setOpen] = React.useState(noteID ? true : false);



    const columns = React.useMemo(
        () => [

            {
                Header: "ID",
                accessor: "id",
                filter: generalFilter,
            },
            {
                id: "Serial Number",
                Header: "Serial Number",
                accessor: "unit_serial_number",
                width: 250,
                minWidth: 250,
                maxWidth: 300,
                Cell: ({ cell }: any) => {
                    return <TravelerModal serialNumber={cell.value} />;
                },
            },
            {
                id: "Project Number",
                Header: "Project Number",
                accessor: "project_number",
                width: 250,
                minWidth: 250,
                maxWidth: 300,
                filter: generalFilter,
            },
            {
                id: "Step Name",
                Header: "Step Name",
                accessor: "name",
                width: 250,
                minWidth: 250,
                maxWidth: 300,
                filter: generalFilter,
            },
            {
                id: "Procedure Name",
                Header: "Procedure Name",
                accessor: "procedure_definition_name",
                width: 250,
                minWidth: 250,
                maxWidth: 300,
                filter: generalFilter,
            },
            {
                id: "Technician Name",
                Header: "Technician Name",
                accessor: "technician_name",
                width: 250,
                minWidth: 250,
                maxWidth: 300,
                filter: generalFilter,
            },
            {
                id: "Customer Name",
                Header: "Customer Name",
                accessor: "customer_name",
                width: 250,
                minWidth: 250,
                maxWidth: 300,
                filter: generalFilter,
            },
            {
                id: "Disposition",
                Header: "Disposition",
                accessor: "disposition_name",
                width: 250,
                minWidth: 250,
                maxWidth: 300,
                filter: generalFilter,
            },

            {
                id: "Work Order",
                Header: "Work Order",
                accessor: "work_order_name",
                width: 250,
                minWidth: 250,
                maxWidth: 300,
                filter: generalFilter,
            },


            {
                id: "Start Datetime",
                Header: "Start Datetime",
                accessor: "start_datetime",
                width: 250,
                minWidth: 250,
                maxWidth: 300,
                Cell: ({ cell }: any) => {
                    return cell.value !== null ? (
                        <p>{dateFormatter(new Date(cell.value))}</p>
                    ) : (
                        <p>N/A</p>
                    );
                },
                filter: generalFilter,
            },
            {
                id: "End Date",
                Header: "End Date",
                accessor: "end_datetime",
                width: 250,
                minWidth: 250,
                maxWidth: 300,
                Cell: ({ cell }: any) => {
                    const promiseDatetime = new Date(cell.value);

                    return cell.value !== null ? (
                        <p>{dateFormatter(promiseDatetime)}</p>
                    ) : (
                        <p>N/A</p>
                    );
                },
                filter: generalFilter,
            },
            // {
            //     id: "Flag",
            //     Header: "Flag",
            //     accessor: "notes[0].subject",

            //     Cell: ({ row }: any) => (
            //         // <div style={{display: 'flex', flexDirection: 'column', width: '100%'}}>
            //         //   <label>{cell.value}</label>
            //         //   <IconButton
            //         //     onClick={() => {
            //         //       setNoteID(cell.value);
            //         //       setOpen(true);
            //         //     }}
            //         //   >
            //         //     <Icon>visibility</Icon>
            //         //   </IconButton>
            //         // </div>


            //         <Button
            //             fullWidth
            //             color="primary"
            //             onClick={() => {
            //                 setNoteID(row.values.note_id);
            //                 setOpen(true);
            //             }}
            //         >
            //             {row.values.Flag}
            //         </Button>
            //     ),

            // },

            {
                Header: "note_id",
                accessor: "note_id",
                filter: generalFilter,
            },

        ],
        []
    );

    if (isLoadingReports) {
        return <LinearProgress />;
    }

    if (isErrorReports) {
        return <ErrorMessage error={reportsError} />;
    }
    return (

        <>
            <Grid
                container
                direction="row"
                alignItems="center"
                spacing={0}>

                <Grid item xs={11}>
                    {/* <Typography variant="h3">Reports</Typography> */}
                </Grid>

                {/* <Grid item xs={1}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={getDownloads}
                    >
                        Download
                    </Button>
                </Grid> */}
                <Grid item xs={6} container justifyContent="flex-start" alignItems="center" spacing={2} style={{ marginTop: '10px', marginBottom: '10px' }}>
                    <Grid item >

                        <TextField
                            id="start-date"
                            label="Start Date"
                            type="date"
                            value={startDate}
                            onChange={handleStartDateChange}
                            InputLabelProps={{
                                shrink: true, // Keeps the label visible when a value is selected
                            }}
                            variant="outlined" // Adds an outline to the input
                        />
                    </Grid>

                    <Grid item >
                        <TextField
                            id="end-date"
                            label="End Date"
                            type="date"
                            value={endDate}
                            onChange={handleEndDateChange}
                            InputLabelProps={{
                                shrink: true, // Keeps the label visible when a value is selected
                            }}
                            variant="outlined" // Adds an outline to the input
                        />
                    </Grid>

                    <Grid item>
                        <Button
                            variant="outlined" // Outlined button
                            color="primary"
                            onClick={searchData}
                        >
                            SEARCH
                        </Button>
                    </Grid>
                </Grid>

            </Grid>
            <div>
                <Typography variant="h3" style={{fontSize:"40px", marginTop: 30, marginBottom: 30 }}>Retest Required Reports</Typography>
                {retestreports && (
                    <LSDBCoreTable
                        columns={columns}
                        data={retestreports.retest_results}
                        hiddenColumns={["id", "note_id"]}
                        getCellProps={(cellInfo: any) => {
                            if (cellInfo.column.Header === "ETA Datetime") {
                                const originalInfo = cellInfo.row.original;
                                const etaDatetime = new Date(originalInfo.eta_datetime);
                                const today = new Date();
                                const dayDiff = Math.floor(
                                    (Date.UTC(
                                        etaDatetime.getFullYear(),
                                        etaDatetime.getMonth(),
                                        etaDatetime.getDate()
                                    ) -
                                        Date.UTC(
                                            today.getFullYear(),
                                            today.getMonth(),
                                            today.getDate()
                                        )) /
                                    (1000 * 60 * 60 * 24)
                                );

                                return {
                                    style: {
                                        backgroundColor:
                                            dayDiff <= 0 ? "red" : dayDiff === 1 ? "yellow" : "green",
                                        fontWeight: "bold",
                                        color: dayDiff === 1 ? "black " : "white",
                                    },
                                };
                            }
                            if (cellInfo.column.Header === "Ready to process?") {
                                if (!cellInfo.value) return {};
                                return { style: { backgroundColor: "green" } };
                            }

                            return {};
                        }}
                    />

                )}

            </div>
        </>
    )
}


